{
  "blocks": [
    {
      "id": "test-fertility-tracker",
      "kind": "test",
      "tags": ["testing", "her", "at-home", "pre-cycle"],
      "title": "At-home LH & PdG Tracker",
      "subtitle": "Urine-based tracking of LH and PdG around ovulation",
      "body": {
        "testName": "At-home LH and PdG Tracker",
        "category": "monitoring",
        "whatItMeasures": "LH surge (predicts ovulation 24-36 hours ahead) and PdG/progesterone (confirms ovulation actually occurred)",
        "howItWorks": "Reusable digital analyzer with test strips and companion app. LH strips detect the surge, PdG strips confirm ovulation 7-10 days later. App tracks patterns across multiple cycles.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Urine test strips"
          },
          {
            "kind": "time",
            "value": "A few minutes per strip"
          },
          {
            "kind": "prep",
            "value": "Test during fertile window and after surge"
          },
          {
            "kind": "results",
            "value": "Instant per strip"
          }
        ],
        "turnaroundTime": "Instant results per strip",
        "costRange": {
          "low": 99,
          "high": 229
        },
        "atHome": true,
        "clinicRequired": false,
        "cycleDay": "Use LH strips during the fertile window; use PdG/progesterone strips 7-10 days after the LH surge or suspected ovulation.",
        "markerTiming": [
          {
            "marker": "LH surge",
            "timing": "Daily during the fertile window, or as the tracker directs",
            "reason": "LH rises shortly before ovulation, so surge testing is timed around the expected fertile window rather than day 2-4 baseline labs."
          },
          {
            "marker": "PdG / progesterone",
            "timing": "Usually 7-10 days after the LH surge or suspected ovulation",
            "reason": "Progesterone metabolites rise after ovulation, so testing too early can miss the post-ovulation increase."
          }
        ],
        "dataPoints": [],
        "section": "cycle-monitoring"
      },
      "sources": [
        {
          "title": "Urinary luteinizing hormone tests: which concentration threshold best predicts ovulation?",
          "authors": "Leiva R, Bouchard T, Boehringer H, Abulla S, Ecochard R",
          "journal": "Frontiers in Public Health",
          "year": 2017,
          "url": "https://pubmed.ncbi.nlm.nih.gov/28443272/",
          "evidenceLevel": "cohort"
        },
        {
          "title": "Use of urinary pregnanediol 3-glucuronide to confirm ovulation",
          "authors": "Ecochard R, Leiva R, Bouchard T, Boehringer H, Direito A, Mariani A, Fehring R",
          "journal": "Steroids",
          "year": 2013,
          "url": "https://pubmed.ncbi.nlm.nih.gov/23994120/",
          "evidenceLevel": "cohort"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [],
  "localeVariants": []
}
